import Vue from 'vue'
import router from '../../router'

export default {
  addNews ({ commit, dispatch }, news) {
    return Vue.axios.post('/about/news', { news })
    .then(({ data }) => {
      commit('ADD_NEW_NEWS', data)
      router.push({ name: 'News' })
      news.photos.forEach(p => {
        dispatch('loadNewsPhoto', { formData: p.data, id: data.id })
      })
      return data
    })
  },
  getNews ({ commit }, id) {
    return Vue.axios.get(`/about/news`)
    .then(({ data }) => commit('ADD_NEWS', data))
  },
  updateNews ({ commit }, news) {
    return Vue.axios.put(`/about/news/${news.id}`, { news })
    .then(() => { router.push({ name: 'News' }) })
  },
  deleteNews ({ commit }, id) {
    return Vue.axios.delete(`/about/news/${id}`)
    .then(() => {
      commit('DELETE_NEWS', id)
      router.push({ name: 'News' })
    })
  },
  loadNewsPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/news/${id}/change-photo`, formData)
    .then(({ data }) => commit('CHANGE_NEWS_PHOTO', data))
  },
  deleteNewsPhoto ({ commit }, data) {
    return Vue.axios.delete(`/about/news/${data.id}/change-photo/${data.photo}`)
    .then(({ data }) => commit('CHANGE_NEWS_PHOTO', data))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/news.js